<template>
  <tr>
    <td v-for="(col, key, colIndex) in cols" :key="colIndex" v-show="($_.isUndefined(col.hidden) || col.hidden == false) && (hiddenCols.indexOf(key) == -1 || col.default)" :class="`column column-${key}`">
      <component v-if="key != 'cb'" :is="colBody(key, row)" :config="configBody(key, row, rowIndex, colIndex, 'body')" @refreshTable="$emitter.emit('TableList.Refresh')"></component>
      <component v-else :is="config.components.ColBodyCb" :config="{ store, storeId, row, rowIndex, cb }" />
    </td>
  </tr>
</template>

<script>
export default {
  components: {
    //
  },
  computed: {
    store() {
      return this.config?.store
    },
    storeId() {
      return this.config?.storeId
    },
    cols() {
      return this.config?.cols || {}
    },
    cb() {
      return this.config?.cb || {}
    },
    screenOptions() {
      return this.config?.screenOptions || {}
    },
    hiddenCols() {
      return this.screenOptions.hidden_cols || []
    }
  },
  methods: {
    configBody(key, row, rowIndex, colIndex, position) {
      return {
        cols: this.cols,
        key,
        row,
        rowIndex,
        colIndex,
        position,
        store: this.store,
        cb: this.cb,
        more: this.config?.more,
        extraAttributes: this.config?.extraAttributes
      }
    },
    colBody: function (name, row) {
      if (_.isArray(row[name]?.actions)) {
        return this.config?.components?.ColBodyItemRowAction
      } else if (this.cols[name]?.type == 'date_time') {
        return this.config?.components?.ColBodyDateTime
      }
      return this.config?.components?.[`ColBody${_.pascalCase(name)}`] || this.config?.components?.ColBodyDefault
    }
  },
  props: {
    config: Object,
    row: {
      type: Object,
      default() {
        return {}
      }
    },
    rowIndex: {
      type: Number
    }
  }
}
</script>
